@if (user && class && cartItem) {
  <div>
    <div class="filters">
      <performer-autocomplete
        [dobFilter]="dobFilter"
        (performerSelected)="performerSelected($event)"
      ></performer-autocomplete>
    </div>
    <cdk-table-component
      [displayColumns]="displayColumns"
      [entities]="tableEntities"
      [dataSource]="dataSource"
    ></cdk-table-component>
    <flat-button color="primary" (click)="addToCart()" [styles]="{ 'margin-top': '20px', width: '100%' }">Add to cart</flat-button>
    @if (errors.length) {
      <div class="cart-error">
        <ul>
          @for (error of errors; track errorTracker($index)) {
            <li>{{ error }}</li>
          }
        </ul>
      </div>
    }
    @if (success) {
      <div class="cart-success">
        {{ success }}
      </div>
    }
  </div>
}
